<template>
  <div class="word-image-container" v-if="wordImage">
    <div>
      <div
        class="word-image-button"
        style="width: 52px; height: 52px; position: relative"
      >
        <div
          id="toggle-word-image-button"
          :class="{ open: wordImageVisible }"
          @click="setWordImageVisibility(!wordImageVisible)"
          title="Laat afbeelding zien"
        >
          &nbsp;
        </div>
      </div>
    </div>

    <transition name="word-image-modal-fade">
      <div
        v-if="wordImageVisible"
        class="word-image-modal"
        @click="setWordImageVisibility(false)"
        role="dialog"
        aria-labelledby="word-image-modalTitle"
        aria-describedby="word-image-modalDescription"
      >
        <div class="word-image-modal-header" id="word-image-modalTitle">
          <slot name="header"></slot>
        </div>

        <div class="word-image-modal-body" id="word-image-modalDescription">
          <div>
            <h3>&nbsp;</h3>
            <img :src="wordImage" alt="word-image" class="word-image" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";

export default {
  name: "c-word-image",
  props: {},
  methods: {
    ...mapMutations({
      SET_WORD_IMAGE_VISIBILITY: "exercise/SET_WORD_IMAGE_VISIBILITY",
    }),
    setWordImageVisibility(payload) {
      this.SET_WORD_IMAGE_VISIBILITY(payload);
    },
  },
  computed: {
    ...mapGetters({
      wordImage: "exercise/getWordImageUrl",
    }),
    ...mapState({
      wordImageVisible: (state) => state.exercise.wordImageVisible,
    }),
  },
};
</script>

<style scoped lang="scss">
.word-image-container {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 91;
}

#toggle-word-image-button {
  cursor: pointer;
  width: 52px;
  height: 52px;
  left: 0px;
  top: -24px;
  position: absolute;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 9999px;
  border: 3px white solid;
  background-color: #386a4c;
  background-image: url("../../../assets/img/buttons/view-image.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 30px 30px;

  &.open {
    background-color: #f2e040;
    background-image: url("../../../assets/img/buttons/close-modal-alt.svg");
    background-size: 20px 20px;
  }
}

.word-image-modal {
  background: #fff;
  border-radius: 15px;
  border: 2px solid green;
  width: 400px;
  //box-shadow: -5px -5px 4px 2px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 35px;
  right: 5px;
}

.word-image-modal-header {
  display: flex;
  position: absolute;
  color: #4aae9b;
  justify-content: space-between;
}

.word-image-modal-body {
  height: 100%;
  padding: 0;
  position: relative;
}

.word-image-modal-body img {
  width: 350px;
}

.word-image-modal-body h3 {
  color: #016d47 !important;
}

.word-image-modal-footer .v-btn {
  max-width: 20%;
  margin: 0 auto;
}

.word-image {
  display: block;
  margin: 0 auto;
}

.btn-word-image-close {
  z-index: 10;
  position: absolute;
  width: 62px !important;
  height: 62px !important;
  padding: 5px;
  right: 5px;
  top: 5px;
  cursor: pointer;
}
</style>

<style>
.word-image-modal-fade-enter,
.word-image-modal-fade-leave-to {
  opacity: 0;
}

.word-image-modal-fade-enter-active,
.word-image-modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
</style>